import React from "react";
import {
  Box,
  Button,
  Container,
  Divider,
  Paper,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const NotFoundPage = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "grey.100",
        display: "flex",
        alignItems: "center",
        py: 2.5,
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={4}
          sx={{
            p: { xs: 4, md: 6 },
            textAlign: "center",
            borderRadius: 2,
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
            color: "white",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Background decorations using Box components */}
          <Box
            sx={{
              position: "absolute",
              top: -6.25,
              right: -6.25,
              width: 25,
              height: 25,
              borderRadius: "50%",
              bgcolor: "rgba(255,255,255,0.1)",
              zIndex: 0,
            }}
          />
          <Box
            sx={{
              position: "absolute",
              bottom: -3.75,
              left: -3.75,
              width: 18.75,
              height: 18.75,
              borderRadius: "50%",
              bgcolor: "rgba(255,255,255,0.05)",
              zIndex: 0,
            }}
          />

          <Box sx={{ position: "relative", zIndex: 1 }}>
            {/* 404 Number */}
            <Typography
              variant="h1"
              component="h1"
              sx={{
                fontSize: { xs: "6rem", md: "8rem" },
                fontWeight: 700,
                mb: 2,
                textShadow: "0 4px 8px rgba(0,0,0,0.3)",
                background: "linear-gradient(45deg, #fff 30%, #f0f0f0 90%)",
                backgroundClip: "text",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              404
            </Typography>

            {/* Main heading */}
            <Typography
              variant="h4"
              component="h2"
              sx={{
                fontWeight: 600,
                mb: 2,
                color: "white",
                fontSize: { xs: "1.5rem", md: "2.125rem" },
              }}
            >
              Oops! No Page Found
            </Typography>

            {/* Description */}
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                opacity: 0.9,
                fontSize: { xs: "1rem", md: "1.1rem" },
                maxWidth: 500,
                mx: "auto",
              }}
            >
              This page doesn't exist or may have been moved. Let's get you back
              on track!
            </Typography>

            <Divider
              sx={{
                bgcolor: "rgba(255,255,255,0.2)",
                my: 4,
                width: 200,
                mx: "auto",
              }}
            />

            {/* Action button */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                mb: 4,
              }}
            >
              <Button
                variant="outlined"
                size="large"
                startIcon={<ArrowBackIcon />}
                sx={{
                  color: "white",
                  borderColor: "rgba(255,255,255,0.5)",
                  px: 3,
                  py: 1.5,
                  "&:hover": {
                    borderColor: "white",
                    bgcolor: "rgba(255,255,255,0.1)",
                    transform: "translateY(-2px)",
                  },
                  transition: (theme) =>
                    theme.transitions.create(
                      ["transform", "background-color"],
                      {
                        duration: theme.transitions.duration.short,
                      }
                    ),
                }}
                onClick={() => window.history.back()}
              >
                Go Back
              </Button>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default NotFoundPage;
